<template>
    <div class="modal--actions">
        <form-button @click="this.$emit('closeDialog')" v-if="!disableClose"><translate>abbrechen</translate></form-button>
        <slot />
    </div>
</template>

<script>
import FormButton from '@partfactory/Shared/Form/FormButton';
export default {
    name: 'ModalActions',
    components: {FormButton},
    props: {
        disableClose: Boolean,
    },
    emit: ['closeDialog'],
};
</script>
